// This file is auto-generated by @hey-api/openapi-ts
import { formDataBodySerializer } from './client';
import { client as _heyApiClient } from './client.gen';
/**
 * Get an account number
 * Gets a specific account number by its ID.
 */
export const accountNumberGetAccountNumber = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/account-numbers/{account_number_id}',
        ...options,
    });
};
/**
 * Update an account number
 * Updates an account number by its ID.
 */
export const accountNumberUpdateAccountNumber = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/account-numbers/{account_number_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Create an ACH positive pay rule
 * Creates an ACH positive pay rule on a bank account.
 */
export const transferAchPositivePayRulesCreateAchPositivePayRule = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/ach-positive-pay-rules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete an ACH positive pay rule
 * Delete an ACH positive pay rule by its ID.
 */
export const transferAchPositivePayRulesDeleteAchPositivePayRule = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/ach-positive-pay-rules/{ach_positive_pay_rule_id}',
        ...options,
    });
};
/**
 * Get an ACH positive pay rule
 * Retrieve a single ACH positive pay rule by its ID.
 */
export const transferAchPositivePayRulesGetAchPositivePayRule = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/ach-positive-pay-rules/{ach_positive_pay_rule_id}',
        ...options,
    });
};
/**
 * List all bank accounts
 * List all bank accounts under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const bankAccountListBankAccounts = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts',
        ...options,
    });
};
/**
 * Create a new bank account
 * Creates a new bank account under an entity.
 */
export const bankAccountCreateBankAccount = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a bank account
 * This deletes a bank account.
 */
export const bankAccountDeleteBankAccount = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}',
        ...options,
    });
};
/**
 * Get a bank account by ID
 * Get a bank account by its ID.
 */
export const bankAccountGetBankAccount = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}',
        ...options,
    });
};
/**
 * Update a bank account
 * Updates a bank account by its ID.
 */
export const bankAccountUpdateBankAccount = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all account numbers from a bank account
 * Lists all the account numbers that point to a specific bank account.
 */
export const accountNumberListAccountNumbers = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}/account-numbers',
        ...options,
    });
};
/**
 * Create a new account number
 * Creates a new account number that points to the associated bank account.
 */
export const accountNumberCreateAccountNumber = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}/account-numbers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List ACH positive pay rules
 * Gets all ACH positive pay rules on a bank account.
 */
export const transferAchPositivePayRulesListAchPositivePayRulesByBankAccount = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}/ach-positive-pay-rules',
        ...options,
    });
};
/**
 * Get bank account summary history
 * Get the summary history of a bank account. This endpoint returns a list of summaries, one summary per day, for a single bank account. Only summaries for the latest 366 days are available. You must set your platform reporting time zone in Platform Settings on Dashboard to use this endpoint ([read more]({{guides.reporting}})).
 */
export const bankAccountGetBankAccountHistory = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}/history',
        ...options,
    });
};
/**
 * Add a bank account owner
 * Adds an additional owner to an existing bank account. This enables joint ownership where multiple entities can have ownership rights. The entity must be verified before being added as an owner and must belong to the same platform as the bank account.
 */
export const bankAccountAddBankAccountOwner = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/bank-accounts/{bank_account_id}/owner',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all counterparties
 * Retrieve all counterparties under your developer account. Filtered results can be retrieved with extra parameters in the query (`account_number`, `routing_number`, etc.).
 */
export const counterpartyListCounterparties = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/counterparties',
        ...options,
    });
};
/**
 * Create a counterparty
 * A counterparty is the legal entity on the other side of the transaction. Depending on the type of transaction, we may need to know more or less about them. A domestic ACH only requires a counterparty's account and routing number. If you include a counterparty name, Column will by default populate `receiver_name` on the ACH transfer request. Domestic and international wires require full name and address. Certain countries may require additional fields. Learn more about country-specific details here.
 */
export const counterpartyCreateCounterparty = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/counterparties',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a counterparty
 * Delete a counterparty.
 */
export const counterpartyDeleteCounterparty = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/counterparties/{counterparty_id}',
        ...options,
    });
};
/**
 * Get a counterparty by ID
 * Retrieve a single counterparty by its ID.
 */
export const counterpartyGetCounterparty = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/counterparties/{counterparty_id}',
        ...options,
    });
};
/**
 * List all crypto counterparties
 * List all crypto counterparties with optional filtering and pagination.
 */
export const transferCryptoListCounterparties = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/counterparties/crypto',
        ...options,
    });
};
/**
 * Create a crypto counterparty
 * Create a new crypto counterparty that can be used as a recipient for outgoing crypto transfers.
 */
export const transferCryptoCreateCounterparty = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/counterparties/crypto',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a crypto counterparty
 * Retrieve a specific crypto counterparty by ID.
 */
export const transferCryptoGetCounterparty = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/counterparties/crypto/{crypto_counterparty_id}',
        ...options,
    });
};
/**
 * List all crypto payment addresses
 * Retrieve all crypto payment addresses under your developer account. Filtered results can be retrieved with extra parameters in the query.
 */
export const cryptoPaymentAddressListCryptoPaymentAddress = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/crypto-payment-addresses',
        ...options,
    });
};
/**
 * Create a crypto payment address
 * Create a new crypto payment address that customers can use to pay stablecoins into and out of. Column will automatically detect incoming payments and settle the equivalent fiat amount into the associated bank account. Outgoing stablecoin transfers can also be initiated from the address.
 */
export const cryptoPaymentAddressCreateCryptoPaymentAddress = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/crypto-payment-addresses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a crypto payment address
 * Close a crypto payment address by its ID. This transitions the address's `status` to `closed`. The address and its transaction history remain visible in `GET` and `LIST` responses, and once closed an address cannot be reopened. On-chain transactions sent to a closed address will arrive and will be detected and recorded against the address, but they will not be converted into fiat. Funds are held and routed into the existing return-funds flow so they can be returned to the sender.
 */
export const cryptoPaymentAddressDeleteCryptoPaymentAddress = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/crypto-payment-addresses/{crypto_payment_address_id}',
        ...options,
    });
};
/**
 * Get crypto payment address
 * Retrieve a single crypto payment address by its ID.
 */
export const cryptoPaymentAddressGetCryptoPaymentAddress = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/crypto-payment-addresses/{crypto_payment_address_id}',
        ...options,
    });
};
/**
 * Accept legal agreement
 * Accept the current legal agreement.
 */
export const dashboardUserAcceptLegalAgreement = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/accept-legal-agreement',
        ...options,
    });
};
/**
 * Create API key
 * Create a new API key for the current platform.
 */
export const apikeyCreateApiKey = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List pending approvals
 * List pending actions that require approval from the caller.
 */
export const approvalsListApprovals = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/approvals',
        ...options,
    });
};
/**
 * Get the approval state of a reviewable object
 * Retrieve the approval state of a single reviewable object.
 */
export const approvalsGetApproval = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/approvals/{object_id}',
        ...options,
    });
};
/**
 * List external apps
 * List external apps available to the current dashboard platform.
 */
export const externalappsListApps = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/apps',
        ...options,
    });
};
/**
 * Get external app
 * Retrieve a single external app available to the current dashboard platform.
 */
export const externalappsGetApp = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/apps/{app_id}',
        ...options,
    });
};
/**
 * Update dashboard user
 * Update a dashboard user's profile information.
 */
export const dashboardUserUpdateDashboardUser = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/dashboard-users/{dashboard_user_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Assign a platform role to a dashboard user
 * Assign a platform role to a dashboard user.
 */
export const roleAssignRole = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/dashboard-users/{dashboard_user_id}/assign-platform-role',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List platform roles for a dashboard user
 * List the platform roles assigned to a dashboard user.
 */
export const dashboardUserListPlatformRoles = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/dashboard-users/{dashboard_user_id}/platform-roles',
        ...options,
    });
};
/**
 * Get dashboard user platform mode settings
 * Retrieve platform-mode dashboard settings for the current dashboard user.
 */
export const dashboardUserGetDashboardUserPlatformModeSettings = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/dashboard-users/platform-settings',
        ...options,
    });
};
/**
 * Update dashboard user platform mode settings
 * Update platform-mode dashboard settings for the current dashboard user.
 */
export const dashboardUserUpdateDashboardUserPlatformModeSettings = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/dashboard-users/platform-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get dashboard user settings
 * Retrieve settings for the current dashboard user.
 */
export const dashboardUserGetDashboardUserSettings = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/dashboard-users/settings',
        ...options,
    });
};
/**
 * Update dashboard user settings
 * Update settings for the current dashboard user.
 */
export const dashboardUserUpdateDashboardUserSettings = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/dashboard-users/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Report suspicious agent input
 * Report potentially malicious instructions encountered by an automated agent.
 */
export const helpSubmit = (options) => {
    return (options.client ?? _heyApiClient).post({
        bodySerializer: null,
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/help',
        ...options,
        headers: {
            'Content-Type': 'text/plain',
            ...options.headers,
        },
    });
};
/**
 * List invites
 * List pending dashboard invites.
 */
export const inviteListInvites = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/invites',
        ...options,
    });
};
/**
 * Create platform invite
 * Create a dashboard invite for a platform.
 */
export const inviteCreatePlatformInvite = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/invites/platforms/{platform_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete invite
 * Delete a dashboard invite by email.
 */
export const inviteDeleteInvite = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/invites/platforms/{platform_id}/email/{email}',
        ...options,
    });
};
/**
 * Resend invite email
 * Resend a dashboard invite email.
 */
export const inviteResendInviteEmail = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/invites/resend_email',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Confirm an email login challenge
 * Redeem a single-use email challenge and create an authenticated dashboard session.
 */
export const loginConfirmLoginEmailChallenge = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/login/email_challenge/confirm',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get dependency graph values
 * Retrieve onboarding dependency graph values.
 */
export const onboardingGetDependencyGraphValues = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/onboarding/depgraph',
        ...options,
    });
};
/**
 * Update dependency graph values
 * Update onboarding dependency graph values.
 */
export const onboardingUpdateDependencyGraphValues = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/onboarding/depgraph',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Upload onboarding file
 * Upload a file for onboarding.
 */
export const onboardingUploadFile = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/onboarding/depgraph/upload-file',
        ...options,
    });
};
/**
 * Get platform
 * Retrieve platform details.
 */
export const platformGetPlatform = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}',
        ...options,
    });
};
/**
 * Update platform
 * Update platform details.
 */
export const platformUpdatePlatform = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List API keys
 * List API keys for the specified platform.
 */
export const apikeyListApiKeys = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/api-keys',
        ...options,
    });
};
/**
 * Delete API key
 * Delete an API key by its ID.
 */
export const apikeyDeleteApiKey = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/api-keys/{api_key_id}',
        ...options,
    });
};
/**
 * Get API key
 * Retrieve a single API key by its ID.
 */
export const apikeyGetApiKey = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/api-keys/{api_key_id}',
        ...options,
    });
};
/**
 * Update API key
 * Update an API key by its ID.
 */
export const apikeyUpdateApiKey = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/api-keys/{api_key_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Reveal API key
 * Retrieve the full API key token. Requires step-up verification.
 */
export const apikeyRevealApiKey = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/api-keys/{api_key_id}/reveal',
        ...options,
    });
};
/**
 * List platform documents
 * List platform documents.
 */
export const documentsListPlatformDocuments = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/documents',
        ...options,
    });
};
/**
 * Upload platform document
 * Upload a platform document.
 */
export const documentsUploadPlatformDocument = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/documents',
        ...options,
    });
};
/**
 * Get document
 * Retrieve a platform document by ID.
 */
export const documentsGetDocument = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/documents/{document_id}',
        ...options,
    });
};
/**
 * Get platform metadata
 * Retrieve platform metadata.
 */
export const platformGetPlatformMetadata = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/metadata',
        ...options,
    });
};
/**
 * Update platform metadata
 * Update platform metadata.
 */
export const platformUpdatePlatformMetadata = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/metadata',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get root entity
 * Retrieve a platform's root entity.
 */
export const identityEntityGetRootEntity = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/root-entities',
        ...options,
    });
};
/**
 * Create business root entity
 * Create a business root entity for a platform.
 */
export const identityEntityCreateBusinessRootEntity = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/root-entities/business',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Create person root entity
 * Create a person root entity for a platform.
 */
export const identityEntityCreatePersonRootEntity = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/{platform_id}/root-entities/person',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get platform mode config
 * Retrieve configuration for the current platform mode.
 */
export const platformGetPlatformModeConfig = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/config',
        ...options,
    });
};
/**
 * Update platform mode config
 * Update configuration for the current platform mode.
 */
export const platformUpdatePlatformModeConfig = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List platform transfer templates
 * List transfer templates for the current platform.
 */
export const transferTemplateListPlatformTransferTemplates = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/transfer-templates',
        ...options,
    });
};
/**
 * Create platform transfer template
 * Create a transfer template for the current platform.
 */
export const transferTemplateCreatePlatformTransferTemplate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/transfer-templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete platform transfer template
 * Delete a transfer template by ID.
 */
export const transferTemplateDeletePlatformTransferTemplate = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/transfer-templates/{transfer_template_id}',
        ...options,
    });
};
/**
 * Get platform transfer template
 * Retrieve a transfer template by ID.
 */
export const transferTemplateGetPlatformTransferTemplate = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/transfer-templates/{transfer_template_id}',
        ...options,
    });
};
/**
 * Update platform transfer template
 * Update a transfer template by ID.
 */
export const transferTemplateUpdatePlatformTransferTemplate = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/platforms/transfer-templates/{transfer_template_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List roles
 * List all roles (platform and custom) available on the platform.
 */
export const roleListRoles = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/roles',
        ...options,
    });
};
/**
 * Create a custom role
 * Create a new custom role with a defined set of permissions.
 */
export const roleCreateCustomRole = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/roles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a custom role
 * Delete a custom role by its ID.
 */
export const roleDeleteCustomRole = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/roles/{role_id}',
        ...options,
    });
};
/**
 * Get a custom role
 * Retrieve a single custom role by its ID.
 */
export const roleGetCustomRole = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/roles/{role_id}',
        ...options,
    });
};
/**
 * Update a custom role
 * Update the permissions assigned to a custom role.
 */
export const roleUpdateCustomRole = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/roles/{role_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Begin passkey login
 * Create usernameless WebAuthn login options using discoverable credentials.
 */
export const webauthnBeginLogin = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/webauthn/login/begin',
        ...options,
    });
};
/**
 * Finish passkey login
 * Verify a WebAuthn assertion and create an authenticated dashboard session.
 */
export const webauthnFinishLogin = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/webauthn/login/finish',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Begin passkey registration
 * Create WebAuthn registration options for the authenticated dashboard user.
 */
export const webauthnBeginRegistration = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/webauthn/register/begin',
        ...options,
    });
};
/**
 * Finish passkey registration
 * Verify a WebAuthn attestation and create a passkey authentication factor.
 */
export const webauthnFinishRegistration = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/dashboard/webauthn/register/finish',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all documents
 * List all documents under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const documentsListDocuments = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/documents',
        ...options,
    });
};
/**
 * Upload a document
 * To upload a file to Column, you will need to send a request with `Content-Type: multipart/form-data`. The request should contain the file you would like to upload, as well as other metadata.
 */
export const documentsUploadRegularDocument = (options) => {
    return (options?.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/documents',
        ...options,
    });
};
/**
 * Get a document
 * Retrieves the details of an existing document.
 */
export const documentsGetDocument2 = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/documents/{document_id}',
        ...options,
    });
};
/**
 * List all entities
 * Retrieve all entities on your platform. Filtered results can be retrieved with extra parameters in the query (`type`, `name`, etc.).
 */
export const identityEntityGetEntities = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities',
        ...options,
    });
};
/**
 * Delete an entity
 * Delete the underlying entity.
 */
export const identityEntityDeleteEntity = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}',
        ...options,
    });
};
/**
 * Get an entity by ID
 * Retrieve a single legal entity by its ID.
 */
export const identityEntityGetEntity = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}',
        ...options,
    });
};
/**
 * Get additional requirements
 * Retrieve submitted additional requirements for an entity.
 */
export const identityEntityGetAdditionalRequirements = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/additional-requirements',
        ...options,
    });
};
/**
 * Submit additional requirements
 * Submit additional requirements that may be configured as part of your compliance program at Column.
 */
export const identityEntitySubmitAdditionalRequirements = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/additional-requirements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List associated persons
 * List the associated persons for a business entity. Results are paginated newest-first; use `limit` (default 10, max 100) with the `starting_after` / `ending_before` person entity ID cursors to page through businesses with many associated persons.
 */
export const identityEntityGetAssociatedPersons = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/associated-persons',
        ...options,
    });
};
/**
 * Link an associated person
 * Link a person entity as an associated person to a business entity.
 */
export const identityEntityLinkAssociatedPerson = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/associated-persons',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Update associated persons
 * Update the associated persons for a business entity.
 */
export const identityEntityUpdateAssociatedPersons = (options) => {
    return (options.client ?? _heyApiClient).put({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/associated-persons',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get entity compliance
 * Retrieve a list of fields that are not yet populated on an entity based on the compliance requirements for your program. Column will work with you to define required fields given your specific use case.
 */
export const identityEntityGetEntityCompliance = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/compliance',
        ...options,
    });
};
/**
 * Get entity evidence
 * Retrieve evidence for an entity with optional filtering.
 */
export const identityEntityGetEntityEvidence = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/evidence',
        ...options,
    });
};
/**
 * Create entity evidence
 * Add evidence to an entity. Supports file, signature, and third-party JSON evidence — if your KYC provider sends you a JSON blob, pass it directly in `data` with `third_party_json` as the `evidence_type`. A single submission can cover several purposes at once: Column creates one evidence record per entry in `purposes`, all referencing the same underlying document or data.
 */
export const identityEntityCreateEntityEvidence = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/evidence',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List entity narratives
 * Retrieve the narratives for an entity, newest first. Deleted narratives are excluded.
 */
export const identityEntityGetEntityNarratives = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/narratives',
        ...options,
    });
};
/**
 * Create an entity narrative
 * Append a free-form note to an entity's customer file, such as the context a reviewer records while collecting CIP/CDD documentation. Narratives are append-only: they cannot be edited after creation, only deleted as individual records.
 */
export const identityEntityCreateEntityNarrative = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/narratives',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete an entity narrative
 * Remove a single narrative from an entity's customer file.
 */
export const identityEntityDeleteEntityNarrative = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/{entity_id}/narratives/{entity_narrative_id}',
        ...options,
    });
};
/**
 * Create a business entity
 * Create a new business entity.
 */
export const identityEntityCreateBusinessEntity = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/business',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Update a business entity
 * Update an existing business entity.
 */
export const identityEntityUpdateBusinessEntity = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/business/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Create a person entity
 * Create a new person entity for individual customers.
 */
export const identityEntityCreatePersonEntity = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/person',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Update a person entity
 * Update an existing person entity.
 */
export const identityEntityUpdatePersonEntity = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/entities/person/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all events
 * Lists all events, inclusive of events sent via webhooks.
 */
export const eventListEvents = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/events',
        ...options,
    });
};
/**
 * Get an event
 * Retrieve a single event by its ID.
 */
export const eventGetEvent = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/events/{event_id}',
        ...options,
    });
};
/**
 * List all webhook events
 * Lists just the events that resulted in webhooks. Useful for reconciling webhooks.
 */
export const eventListWebhookEvents = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/events/webhook',
        ...options,
    });
};
/**
 * Validate an IBAN
 * Validate the format of an IBAN and check whether it is registered with the given financial institution. However, we cannot verify if the account is still open.
 */
export const financialInstitutionGetIban = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/iban/{iban}',
        ...options,
    });
};
/**
 * List financial institutions
 * List all financial institutions. Filtered results can be retrieved with extra parameters in your queries.
 */
export const financialInstitutionListFinancialInstitutions = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/institutions',
        ...options,
    });
};
/**
 * Get a financial institution
 * Retrieve a single financial institution by its ABA number or BIC.
 */
export const financialInstitutionGetFinancialInstitution = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/institutions/{routing_number}',
        ...options,
    });
};
/**
 * List interest configs
 * Retrieve multiple interest configs on your platform.
 */
export const interestsListConfigs = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/configs',
        ...options,
    });
};
/**
 * Create interest config
 * Create an interest configuration for your platform.
 */
export const interestsCreateConfig = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/configs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get interest config
 * Retrieve a single interest config by its ID.
 */
export const interestsGetConfig = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/configs/{interest_config_id}',
        ...options,
    });
};
/**
 * Update interest config
 * Update an interest config.
 */
export const interestsUpdateConfig = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/configs/{interest_config_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List interest payouts
 * Retrieve multiple interest payouts of your platform.
 */
export const interestsListPayouts = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/payouts',
        ...options,
    });
};
/**
 * Get interest payout
 * Retrieve a single interest payout by its ID.
 */
export const interestsGetPayout = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/payouts/{interest_payout_id}',
        ...options,
    });
};
/**
 * List pivot interest rates
 * Retrieve multiple pivot interest rates.
 */
export const interestsListPivotRates = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/pivot-rates',
        ...options,
    });
};
/**
 * Create pivot interest rate
 * Create a pivot interest rate for your platform.
 */
export const interestsCreatePivotRate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/pivot-rates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete pivot interest rate
 * Delete a pivot interest rate.
 */
export const interestsDeletePivotRate = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/pivot-rates/{pivot_interest_rate_id}',
        ...options,
    });
};
/**
 * Get pivot interest rate
 * Retrieve a single pivot interest rate by its ID.
 */
export const interestsGetPivotRate = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/pivot-rates/{pivot_interest_rate_id}',
        ...options,
    });
};
/**
 * Update pivot interest rate
 * Update a pivot interest rate before 4:00pm PST on its effective date.
 */
export const interestsUpdatePivotRate = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/interests/pivot-rates/{pivot_interest_rate_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List card accounts
 * Retrieve a list of card accounts.
 */
export const cardsListCardAccounts = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-accounts',
        ...options,
    });
};
/**
 * Create card account
 * Create a new card account.
 */
export const cardsCreateCardAccount = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get card account by ID
 * Retrieve detailed information about a specific card account.
 */
export const cardsGetCardAccount = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-accounts/{card_account_id}',
        ...options,
    });
};
/**
 * Close card account
 * Close a card account.
 */
export const cardsCloseCardAccount = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-accounts/{card_account_id}/close',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Reinstate card account
 * Reinstate a previously suspended card account.
 */
export const cardsReinstateCardAccount = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-accounts/{card_account_id}/reinstate',
        ...options,
    });
};
/**
 * Suspend card account
 * Suspend a card account.
 */
export const cardsSuspendCardAccount = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-accounts/{card_account_id}/suspend',
        ...options,
    });
};
/**
 * Create card authorization policy
 * Create a new card authorization policy and its initial version.
 */
export const cardsCreateCardAuthorizationPolicy = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-authorization-policies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List card authorization policy versions
 * Retrieve a list of versions for the specified card authorization policy.
 */
export const cardsListCardAuthorizationPolicyVersions = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-authorization-policy-versions',
        ...options,
    });
};
/**
 * Create card authorization policy version
 * Create a new version for an existing card authorization policy.
 */
export const cardsCreateCardAuthorizationPolicyVersion = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-authorization-policy-versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete card authorization policy version
 * Delete a specific card authorization policy version.
 */
export const cardsDeleteCardAuthorizationPolicyVersion = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-authorization-policy-versions/{card_authorization_policy_version_id}',
        ...options,
    });
};
/**
 * Get card authorization policy version
 * Retrieve a specific card authorization policy version by its ID.
 */
export const cardsGetCardAuthorizationPolicyVersion = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-authorization-policy-versions/{card_authorization_policy_version_id}',
        ...options,
    });
};
/**
 * Update card authorization policy version
 * Update a specific card authorization policy version.
 */
export const cardsUpdateCardAuthorizationPolicyVersion = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-authorization-policy-versions/{card_authorization_policy_version_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Check card dispute eligibility
 * Check whether a card transaction can be disputed without creating a dispute.
 */
export const cardsCheckCardDisputeEligibility = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-dispute-eligibility',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List card disputes
 * Retrieve a list of card disputes.
 */
export const cardsListCardDisputes = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-disputes',
        ...options,
    });
};
/**
 * Create card dispute
 * Create a local card dispute for a settled card transaction.
 */
export const cardsCreateCardDispute = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-disputes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get card dispute by ID
 * Retrieve detailed information about a specific card dispute.
 */
export const cardsGetDispute = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-disputes/{card_dispute_id}',
        ...options,
    });
};
/**
 * Add card dispute evidence
 * Add document or narrative evidence to a card dispute.
 */
export const cardsAddCardDisputeEvidence = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-disputes/{card_dispute_id}/evidence',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Recall card dispute
 * Recall a local card dispute before it has been submitted to the card network.
 */
export const cardsRecallCardDispute = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-disputes/{card_dispute_id}/recall',
        ...options,
    });
};
/**
 * Respond to card dispute
 * Queue a response to the card network for the current dispute stage.
 */
export const cardsRespondCardDispute = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-disputes/{card_dispute_id}/respond',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Submit card dispute
 * Queue a local card dispute for network submission.
 */
export const cardsSubmitCardDispute = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-disputes/{card_dispute_id}/submit',
        ...options,
    });
};
/**
 * List card programs
 * Retrieve a list of card programs.
 */
export const cardsListCardPrograms = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-programs',
        ...options,
    });
};
/**
 * Get card program by ID
 * Retrieve detailed information about a specific card program.
 */
export const cardsGetCardProgram = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-programs/{card_program_id}',
        ...options,
    });
};
/**
 * Update card program
 * Update a card program.
 */
export const cardsUpdateCardProgram = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-programs/{card_program_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List card tokens
 * Retrieve a list of card tokens.
 */
export const cardsListCardTokens = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-tokens',
        ...options,
    });
};
/**
 * Get card token by ID
 * Retrieve detailed information about a specific card token.
 */
export const cardsGetCardToken = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-tokens/{card_token_id}',
        ...options,
    });
};
/**
 * Activate card token
 * Reactivate a paused card token. Only tokens in the `paused` status can be activated. Fires an `issuing.card_token.activated` event.
 */
export const cardsActivateCardToken = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-tokens/{card_token_id}/activate',
        ...options,
    });
};
/**
 * Deactivate card token
 * Permanently deactivate a card token. A token in any non-terminal status can be deactivated. This action cannot be undone. Fires an `issuing.card_token.deactivated` event.
 */
export const cardsDeactivateCardToken = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-tokens/{card_token_id}/deactivate',
        ...options,
    });
};
/**
 * Pause card token
 * Temporarily pause a card token. Authorizations with the token are declined until it is reactivated. Only tokens in the `active` status can be paused. Fires an `issuing.card_token.paused` event.
 */
export const cardsPauseCardToken = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-tokens/{card_token_id}/pause',
        ...options,
    });
};
/**
 * List card transactions
 * Retrieve a list of card transactions.
 */
export const cardsListCardTransactions = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-transactions',
        ...options,
    });
};
/**
 * Get card transaction by ID
 * Retrieve detailed information about a specific card transaction.
 */
export const cardsGetCardTransaction = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/card-transactions/{card_transaction_id}',
        ...options,
    });
};
/**
 * List cards
 * Retrieve a list of cards.
 */
export const cardsListCards = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards',
        ...options,
    });
};
/**
 * Create card
 * Create a new card with a required card_account_id parameter.
 */
export const cardsCreateCard = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get card
 * Retrieve detailed information about a specific card.
 */
export const cardsGetCard = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}',
        ...options,
    });
};
/**
 * Update card
 * Update a card's authorization policy.
 */
export const cardsUpdateCard = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Activate card
 * Activate a card.
 */
export const cardsActivateCard = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/activate',
        ...options,
    });
};
/**
 * Deactivate card
 * Permanently deactivate a card. The card's status changes to `inactive` and cannot be reactivated.
 */
export const cardsDeactivateCard = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/deactivate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Pause card
 * Temporarily pause a card. The card's status changes to paused and all authorization requests will be declined until the card is resumed.
 */
export const cardsPauseCard = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/pause',
        ...options,
    });
};
/**
 * Update card PIN
 * Update a debit card's PIN.
 */
export const cardsUpdateCardPin = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/pin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Renew card
 * Renew a card to extend its expiration date while keeping the same PAN. The card's `sequence_number` is incremented.
 */
export const cardsRenewCard = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/renew',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Replace card
 * Replace a card with a new card that has a different PAN. Use this when a card is lost, stolen, fraudulent, or voluntarily replaced. The original card is automatically deactivated.
 */
export const cardsReplaceCard = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/replace',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Unified card details reveal endpoint
 */
export const cardsRevealCardDetails = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/reveal',
        ...options,
    });
};
/**
 * Create card reveal token
 * Create a reveal token for a card.
 */
export const cardsCreateCardRevealToken = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/issuing/cards/{card_id}/reveal-tokens',
        ...options,
    });
};
/**
 * List all loans
 * List all loans under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const lendingLoanListLoans = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans',
        ...options,
    });
};
/**
 * Create a new loan
 * Creates a new loan under an entity.
 */
export const lendingLoanCreateLoan = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a loan by ID
 * Retrieve a single loan by its ID.
 */
export const lendingLoanGetLoan = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/{loan_id}',
        ...options,
    });
};
/**
 * Update a loan
 * Updates a loan by its ID.
 */
export const lendingLoanUpdateLoan = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/{loan_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get loan summary history
 * Retrieve daily summary history for a specific loan. [Read more]({{lending.report}}).
 */
export const lendingLoanGetLoanHistory = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/{loan_id}/history',
        ...options,
    });
};
/**
 * Create a loan sale
 * Creates a loan sale for a specific loan.
 */
export const lendingSaleCreateSale = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/{loan_id}/sales',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all disbursements
 * List all disbursements under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const lendingDisbursementsListDisbursements = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/disbursements',
        ...options,
    });
};
/**
 * Create a disbursement
 * Creates a disbursement for a loan. [Read more]({{lending.report}}).
 */
export const lendingDisbursementsCreateDisbursement = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/disbursements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a disbursement
 * Retrieve a single disbursement by its ID.
 */
export const lendingDisbursementsGetDisbursement = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/disbursements/{loan_disbursement_id}',
        ...options,
    });
};
/**
 * Update a disbursement hold
 * Update a disbursement hold for a loan.
 */
export const lendingDisbursementsUpdateDisbursementHold = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/disbursements/{loan_disbursement_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Cancel a disbursement hold
 * Cancel a disbursement hold for a loan.
 */
export const lendingDisbursementsCancelDisbursementHold = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/disbursements/{loan_disbursement_id}/cancel',
        ...options,
    });
};
/**
 * Clear a disbursement hold
 * Clear a disbursement hold for a loan.
 */
export const lendingDisbursementsClearDisbursementHold = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/disbursements/{loan_disbursement_id}/clear',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all payments
 * List all payments under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const lendingPaymentsListLoanPayments = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/payments',
        ...options,
    });
};
/**
 * Create a payment
 * Creates a payment for a loan. [Read more]({{lending.report}}).
 */
export const lendingPaymentsCreateLoanPayment = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a payment
 * Retrieve a single loan payment by its ID.
 */
export const lendingPaymentsGetLoanPayment = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/payments/{loan_payment_id}',
        ...options,
    });
};
/**
 * Return a payment
 * Return a loan payment by its ID.
 */
export const lendingPaymentsReturnLoanPayment = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/payments/{loan_payment_id}/return',
        ...options,
    });
};
/**
 * List loan programs
 * List all loan programs for your platform. No query parameters are available - all loan programs for your platform will be returned.
 */
export const lendingLoanListLoanPrograms = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/programs',
        ...options,
    });
};
/**
 * Get a loan program
 * Retrieve a single loan program by its ID.
 */
export const lendingLoanGetLoanProgram = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/programs/{loan_program_id}',
        ...options,
    });
};
/**
 * Update loan program
 * It's unlikely that you will need to update a loan program. Please work with your Column team / Solution Engineer to update a loan program.
 */
export const lendingLoanUpdateLoanProgram = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/programs/{loan_program_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all loan sales
 * List loan sales under your platform.
 */
export const lendingSaleListSales = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/sales',
        ...options,
    });
};
/**
 * Get a loan sale
 * Retrieve a single loan sale by its ID.
 */
export const lendingSaleGetSale = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/sales/{loan_sale_id}',
        ...options,
    });
};
/**
 * Get loan sale summaries for loans available for sale
 * Get loan sale summaries for loans available for sale. Data returned by this API are updated daily after `loan_daily_summary` reports are generated. [Read more]({{lending.report}}).
 */
export const lendingSaleGetDailyLoansAvailableForSale = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/sales/summaries/available',
        ...options,
    });
};
/**
 * Get loan sale summaries for loans already sold
 * Get loan sale summaries for loans already sold. Data returned by this API are updated daily after `loan_daily_summary` reports are generated. [Read more]({{lending.report}}).
 */
export const lendingSaleGetDailySoldLoans = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/loans/sales/summaries/sold',
        ...options,
    });
};
/**
 * List market rates
 * Retrieve all market rates published by the New York Fed on a given date.
 */
export const miscGetMarketRates = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/market-rates',
        ...options,
    });
};
/**
 * List all settlement reports
 * List all available settlement reports under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const reportingListSettlementReports = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/reporting',
        ...options,
    });
};
/**
 * Schedule a settlement report
 */
export const reportingScheduleSettlementReport = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/reporting',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a settlement report by ID
 * Get a settlement report by its ID. Please refer to our [Reporting Guides]({{guides.reporting}}) for more details.
 */
export const reportingGetSettlementReport = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/reporting/{settlement_report_id}',
        ...options,
    });
};
/**
 * Get a customized bank account statement
 * Generate a customized bank account statement for a specific bank account and date range. The response is a CSV file download.
 */
export const bankAccountExportBankAccountActivities = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/reporting/customized-bank-account-statement',
        ...options,
    });
};
/**
 * Deposit an issued check
 * Simulates the deposit of an issued check. This API is always enabled, and is not affected by the operating hours of the sandbox Fed Check21 system.
 */
export const transferChecksDepositIssuedCheck = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/deposit-issued-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Simulate an interest payout
 * Simulates an interest payout to the given interest bearing product.
 */
export const interestsPayoutInterest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/interests/payouts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Create sandbox card program
 * Creates a sandbox card program for issuing simulation workflows.
 */
export const cardsCreateCardProgram = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/issuing/card-programs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive an ACH Credit
 * Simulates an incoming ACH Credit transfer to an account for the amount specified. To more accurately represent a production environment, we process incoming ACH transfers every hour. You will not see the effects of an incoming ACH transfer until the ACH is processed.
 */
export const transferAchReceiveAchCreditTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/receive-ach-credit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive an ACH Debit
 * Simulates an incoming ACH Debit transfer from an account for the amount specified. To more accurately represent a production environment, we process incoming ACH transfers every hour. You will not see the effects of an incoming ACH transfer until the ACH is processed.
 */
export const transferAchReceiveAchDebitTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/receive-ach-debit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive a correspondent SWIFT message
 * Simulates receiving an incoming correspondent SWIFT pacs.008 message. Accepts raw pacs.008 XML, auto-configures the correspondent platform infrastructure, and queues the message for async processing through the correspondent banking pipeline.
 */
export const transferSwiftReceiveCorrespondentSwift = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/receive-correspondent-swift',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive an international wire
 * Simulates an incoming international wire transfer to an account for the amount specified.
 */
export const transferWireReceiveInternationalWire = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/receive-international-wire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive a wire transfer
 * Simulates an incoming wire transfer to an account for the amount specified. We recommend using this API to set a balance on your account in the sandbox environment. This API is always enabled, and is not affected by the operating hours of the sandbox Fedwire system.
 */
export const transferWireReceiveWireTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/receive-wire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive a wire drawdown request
 * Simulates an incoming wire drawdown request into the specified account number ID.
 */
export const transferWireReceiveWireDrawdownRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/receive-wire-drawdown-request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive a wire return request
 * Simulates an incoming wire return request for a simulated incoming wire transfer.
 */
export const transferWireReceiveWireReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/receive-wire-return-request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Create a tax form
 * Simulates the creation of a tax form for an entity. This allows you to test the tax form workflow including filing statuses, mailing, and webhook events. The normal `7` calendar days grace period for filing will be ignored in simulations.
 */
export const taxFormsCreateTaxForm = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/tax-forms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Settle ACH transfer
 * Forces the settlement of an outgoing ACH transfer, regardless of the operating hours of the Sandbox Fed.
 */
export const transferAchSettleAchTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/transfers/ach/settle',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Settle check deposit
 * Forces the settlement of a deposited check. After a check is deposited in sandbox, it is going to move from a `pending_deposit` state to a `deposited` state within an hour to simulate check forwarding to the Fed. This endpoint allows you to force settlement after the check is transitioned to a `deposited` state. This will transition the transfer to `settled` and make funds available immediately.
 */
export const transferChecksSettleCheckTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/transfers/checks/settle',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive a realtime transfer
 * Simulates an incoming realtime transfer to an account for the amount specified.
 */
export const transferRealtimeReceiveCredit = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/transfers/realtime/receive-credit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Receive a realtime RFP (Request for Payment)
 * Simulates an incoming Realtime RFP to an account for the amount specified.
 */
export const transferRealtimeReceiveRfp = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/transfers/realtime/receive-rfp',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Settle wire transfer
 * Forces the submission and settlement of an outgoing Wire transfer, regardless of the operating hours of the Sandbox Fed. The wire message should move from `PENDING_SUBMISSION` to `COMPLETED` after this API call.
 */
export const transferWireSettleWireTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/simulate/transfers/wire/settle',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all tax forms
 * List all tax forms with optional filtering and pagination.
 */
export const taxFormListTaxForms = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/tax-forms',
        ...options,
    });
};
/**
 * Get a tax form
 * Retrieve a specific tax form by ID.
 */
export const taxFormGetTaxForm = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/tax-forms/{tax_form_id}',
        ...options,
    });
};
/**
 * Cancel scheduled mailing
 * Cancel a scheduled mailing of a tax form.
 */
export const taxFormCancelMailing = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/tax-forms/{tax_form_id}/cancel-mail',
        ...options,
    });
};
/**
 * Schedule mailing
 * Schedule physical mailing of a tax form to the taxpayer. If federal filing is required, the tax form must have been accepted by the IRS. If state filing is required, the tax form must have been accepted by the state.
 */
export const taxFormScheduleMailing = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/tax-forms/{tax_form_id}/mail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all transfers
 * List all transfers across all transfer types under your platform.
 */
export const transferSearchTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers',
        ...options,
    });
};
/**
 * List all ACH transfers
 * Retrieve all ACH transfers under your developer account. Filtered results can be retrieved with extra parameters in the query (`bank_account_id`, `counterparty_id`, etc.).
 */
export const transferAchListTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach',
        ...options,
    });
};
/**
 * Create an ACH transfer
 * Creates an ACH transfer between an account and a `counterparty`.
 */
export const transferAchCreateTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get an ACH transfer
 * Retrieves a single transfer by its ID.
 */
export const transferAchGetTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/{ach_transfer_id}',
        ...options,
    });
};
/**
 * Cancel an ACH transfer
 * Cancels an ACH transfer before it is sent to the Federal Reserve. This action can be performed only if a given transfer is `INITIATED`. You can read more about [ACH states here]({{ach.states}}).
 */
export const transferAchCancelTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/{ach_transfer_id}/cancel',
        ...options,
    });
};
/**
 * Get an ACH return
 * Retrieve the return processing details of an ACH transfer. The return may be either filed by your platform, or sent to you by other RDFIs.
 */
export const transferAchGetReturn = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/{ach_transfer_id}/return',
        ...options,
    });
};
/**
 * Create an ACH return
 * Submit a request to return an incoming ACH transfer that is sent by other ODFIs (i.e. Column is the RDFI). At most one return request can be submitted for each incoming ACH transfer. You can read more about [ACH returns here]({{ach.returns.create}}).
 */
export const transferAchCreateReturn = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/{ach_transfer_id}/return',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Reverse an ACH transfer
 * Reverse an erroneous outgoing ACH transfer. You can read more about [ACH Reversals]({{ach.reversals}}).
 */
export const transferAchReverseTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/{ach_transfer_id}/reverse',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Review an ACH transfer
 * Approve or reject an ACH transfer that is pending review.
 */
export const transferAchReviewTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/{ach_transfer_id}/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List ACH transfer batches
 * List ACH transfer batches with optional filtering and pagination.
 */
export const transferAchBatchListBatches = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches',
        ...options,
    });
};
/**
 * Create an ACH transfer batch
 * Create a new ACH transfer batch for bulk import of transfers via NACHA or CSV.
 */
export const transferAchBatchCreateBatch = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get an ACH transfer batch
 * Retrieve a single ACH transfer batch by its ID.
 */
export const transferAchBatchGetBatch = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches/{ach_transfer_batch_id}',
        ...options,
    });
};
/**
 * Cancel an ACH transfer batch
 * Cancel an ACH transfer batch that has not yet been confirmed.
 */
export const transferAchBatchCancelBatch = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches/{ach_transfer_batch_id}/cancel',
        ...options,
    });
};
/**
 * Confirm an ACH transfer batch
 * Confirm a validated ACH transfer batch and begin creating individual ACH transfers from its records.
 */
export const transferAchBatchConfirmBatch = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches/{ach_transfer_batch_id}/confirm',
        ...options,
    });
};
/**
 * Upload a file to an ACH transfer batch
 * Upload a NACHA or CSV file to a pending ACH transfer batch.
 */
export const transferAchBatchUploadFile = (options) => {
    return (options.client ?? _heyApiClient).post({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches/{ach_transfer_batch_id}/file',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers,
        },
    });
};
/**
 * List records in an ACH transfer batch
 * List individual records within an ACH transfer batch with optional filtering and pagination.
 */
export const transferAchBatchListBatchRecords = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches/{ach_transfer_batch_id}/records',
        ...options,
    });
};
/**
 * Get an ACH transfer batch record
 * Retrieve a single record within an ACH transfer batch by its ID.
 */
export const transferAchBatchGetBatchRecord = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/batches/{ach_transfer_batch_id}/records/{ach_transfer_batch_record_id}',
        ...options,
    });
};
/**
 * List all ACH returns
 * Retrieve the return processing details of all ACH transfers under your developer account, including both returns filed by your platform and returns sent by other RDFIs.
 */
export const transferAchListReturns = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/ach/returns',
        ...options,
    });
};
/**
 * Get an admin transfer
 * Retrieve details of an admin transfer by its ID.
 */
export const transferAdminGetAdminTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/admin/{admin_transfer_id}',
        ...options,
    });
};
/**
 * List transfer batches
 * List transfer batches with optional filtering and pagination.
 */
export const transferBatchListTransferBatches = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/batches',
        ...options,
    });
};
/**
 * Create a transfer batch
 * Create a new transfer batch that groups multiple transfers for review.
 */
export const transferBatchCreateTransferBatch = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/batches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a transfer batch
 * Delete a transfer batch by its ID.
 */
export const transferBatchDeleteTransferBatch = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/batches/{transfer_batch_id}',
        ...options,
    });
};
/**
 * Get a transfer batch
 * Retrieve a single transfer batch by its ID.
 */
export const transferBatchGetTransferBatch = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/batches/{transfer_batch_id}',
        ...options,
    });
};
/**
 * Update a transfer batch
 * Update a transfer batch's metadata or status.
 */
export const transferBatchUpdateTransferBatch = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/batches/{transfer_batch_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all book transfers
 * Retrieve all book transfers under your developer account. Filtered results can be retrieved with extra parameters in the query (`sender_bank_account_id`, `receiver_bank_account_id`, etc.).
 */
export const transferBookListBookTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/book',
        ...options,
    });
};
/**
 * Create a book transfer
 * A book transfer is a transaction between two Column accounts that you own. They can happen instantly and can be sent 24 hours a day, 7 days a week. Both accounts need to be under your platform, but don't need to be under the same entity. Alternatively, you can send a book transfer in two steps, using the "hold" parameter and "clear" method. Book transfers in a "hold" state can be updated and canceled. There is no reversal functionality for book transfers. Simply swap the `sender_account_number_id` and `receiver_account_number_id` and repeat the request.
 */
export const transferBookCreateBookTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/book',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a book transfer
 * Retrieve a single book transfer by its ID.
 */
export const transferBookGetBookTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/book/{book_transfer_id}',
        ...options,
    });
};
/**
 * Update a book transfer
 * Update a book transfer by its ID. Transfer must be in a "hold" state. Only the `amount` can be updated.
 */
export const transferBookUpdateBookTransfer = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/book/{book_transfer_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Cancel a book transfer
 * Cancel a book transfer hold by its ID. Transfer must be in a "hold" state.
 */
export const transferBookCancelBookTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/book/{book_transfer_id}/cancel',
        ...options,
    });
};
/**
 * Clear a book transfer
 * Clear a book transfer by its ID. Transfer must be in a "hold" state. If the `amount` is specified, then that amount will be cleared, regardless of the amount of the hold. If no amount is specified, then the amount of the hold will be cleared.
 */
export const transferBookClearBookTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/book/{book_transfer_id}/clear',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all check transfers
 * Retrieve all check transfers on your platform.
 */
export const transferCheckListCheckTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks',
        ...options,
    });
};
/**
 * Get a check transfer
 * Retrieve a single check transfer by its ID.
 */
export const transferCheckGetCheckTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/{check_transfer_id}',
        ...options,
    });
};
/**
 * Get a check preview PDF for an issued transfer
 * Get a preview PDF for a transfer. Only available for checks delivered by Column.
 */
export const transferCheckGetPreviewPdf = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/{check_transfer_id}/preview-pdf',
        ...options,
    });
};
/**
 * Create a check return
 * Submit a request to return an incoming check transfer received from an ODFI. At most one return request can be submitted for each check. You can read more about check returns here.
 */
export const transferCheckCreateCheckReturn = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/{check_transfer_id}/return',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get check transfer returns
 * Retrieve all returns for a check transfer by the check transfer ID.
 */
export const transferCheckGetCheckReturns = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/{check_transfer_id}/returns',
        ...options,
    });
};
/**
 * Stop a check transfer
 * Create a stop payment on a single check transfer by its ID. A check can only be stopped if it is of type debit and is in `issued` or `manual_review` status. A stopped check will move into a `pending_stop` status with a `pending_stop_at` timestamp until funds are released, at which point the status will be `stopped` and the `stopped_at` timestamp will be set.
 */
export const transferCheckStopPayment = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/{check_transfer_id}/stop-payment',
        ...options,
    });
};
/**
 * Deposit a check
 * Deposit a check into a Column bank account.
 */
export const transferCheckDepositCheck = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/deposit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Capture back of check
 * Preprocess an image of the back of a check. The response includes a processed TIFF image that conforms to the ICL file standard. The response fields are in the same format as the input of the check deposit API. We recommend placing the check on a darker background, such as a darker shade if the check paper is white. The check itself should occupy the majority of the image. Additionally, we suggest using a higher DPI to ensure that the characters are easily recognizable. It is also advisable to correctly orient the check. Note that the MICR and amount parsing is still in Beta. We recommend you validate parsed data with the user before submitting a check deposit.
 */
export const transferCheckProcessCheckBackImage = (options) => {
    return (options.client ?? _heyApiClient).post({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/image/back',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers,
        },
    });
};
/**
 * Capture front of check
 * Preprocess an image of the front of a check. The response includes the parsed MICR Line data, deposit amount, and a processed TIFF image that conforms to the ICL file standard. The response fields are in the same format as the input of the check deposit API. We recommend placing the check on a darker background, such as a darker shade if the check paper is white. The check itself should occupy the majority of the image. Additionally, we suggest using a higher DPI to ensure that the characters are easily recognizable. It is also advisable to correctly orient the check. Note that the MICR and amount parsing is still in Beta. We recommend you validate parsed data with the user before submitting a check deposit.
 */
export const transferCheckProcessCheckFrontImage = (options) => {
    return (options.client ?? _heyApiClient).post({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/image/front',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers,
        },
    });
};
/**
 * Issue a check
 * Issue a check to a specific payee for a given amount. If mail_check_request is included, the check will be delivered by Column too.
 */
export const transferCheckIssueCheck = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/issue',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all check lockboxes
 * Retrieve all check lockboxes under your platform.
 */
export const transferCheckLockboxListLockboxes = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/lockboxes',
        ...options,
    });
};
/**
 * Create a check lockbox
 * Create and assign a check lockbox to a bank account or account number. If you specify a bank account, Column assigns the lockbox to the account's default account number. Each account number can have at most one linked lockbox.
 */
export const transferCheckLockboxCreateLockbox = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/lockboxes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a check lockbox
 * Close a check lockbox by its ID. Once closed, the lockbox can no longer be used to receive mailed checks.
 */
export const transferCheckLockboxDeleteLockbox = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/lockboxes/{lockbox_id}',
        ...options,
    });
};
/**
 * Get a check lockbox
 * Retrieve a single check lockbox by its ID.
 */
export const transferCheckLockboxGetLockbox = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/lockboxes/{lockbox_id}',
        ...options,
    });
};
/**
 * List all check returns
 * Retrieve the return processing details of all check returns under your platform, including returns created by you and other financial institutions.
 */
export const transferCheckListCheckReturns = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/checks/returns',
        ...options,
    });
};
/**
 * List all crypto transfers
 * Retrieve all crypto transfers under your developer account. Filtered results can be retrieved with extra parameters in the query.
 */
export const transferCryptoListTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/crypto',
        ...options,
    });
};
/**
 * Create an outgoing crypto transfer
 * Create an outgoing crypto transfer to send stablecoins to a crypto counterparty. The transfer will be funded from the bank account associated with the specified crypto payment address.
 */
export const transferCryptoCreateTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/crypto',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get crypto transfer
 * Retrieve a single crypto transfer by its ID.
 */
export const transferCryptoGetTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/crypto/{crypto_transfer_id}',
        ...options,
    });
};
/**
 * List all international wire transfers
 * Retrieve all international wire transfers under your platform.
 */
export const transferSwiftListTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire',
        ...options,
    });
};
/**
 * Create an international wire transfer
 * Create an international wire transfer between a Column account and a counterparty. Transfer status can be tracked via the Tracking API.
 */
export const transferSwiftCreateTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get international wire transfer
 * Retrieve a single international wire transfer by its ID.
 */
export const transferSwiftGetTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/{swift_transfer_id}',
        ...options,
    });
};
/**
 * Create international wire amendment
 * Create an amendment for an international wire transfer that has been delivered. Amendments can only be created for outgoing transfers in specific statuses and only one amendment per transfer is allowed.
 * **Amendment Eligibility Requirements**: - Only **outgoing transfers** can be amended - Transfer must be in `initiated`, `submitted`, `delivered`, `settled`, or `completed` status - Only **one amendment per transfer** is allowed
 */
export const transferSwiftCreateAmendment = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/{swift_transfer_id}/amendment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Cancel an outgoing international wire
 * Send a cancellation request to recall funds from the beneficiary for an outgoing international wire transfer. The beneficiary may approve or reject the cancellation request. Cancellation status can be tracked via the Tracking API.
 */
export const transferSwiftCancelTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/{swift_transfer_id}/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Return an incoming international wire
 * Return an incoming international wire transfer to the originator. Return status can be tracked via the Tracking API.
 */
export const transferSwiftReturnTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/{swift_transfer_id}/return',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Track an international wire transfer
 * Retrieve tracking information for an international wire transfer.
 */
export const transferSwiftTrackTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/{swift_transfer_id}/tracking',
        ...options,
    });
};
/**
 * Request a foreign exchange quote
 * Request a foreign exchange quote to exchange USD to other currencies for international wire transfers. Quotes are not booked until they are used in transfer requests.
 */
export const transferSwiftQueryFxQuote = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/fx-rate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get FX rate sheet
 * Retrieve the FX rate sheet for all foreign currencies that Column supports.
 */
export const transferSwiftQueryFxRateSheet = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/fx-rate-sheet',
        ...options,
    });
};
/**
 * Get a foreign exchange quote
 * Retrieve a single foreign exchange quote by its ID.
 */
export const transferSwiftGetFxQuote = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/fx-rate/{fx_quote_id}',
        ...options,
    });
};
/**
 * Book a foreign exchange quote
 * Book a single foreign exchange quote by its ID. If the quote has already been booked before, it will be returned.
 */
export const transferSwiftBookFxQuote = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/fx-rate/{fx_quote_id}/book',
        ...options,
    });
};
/**
 * Cancel a foreign exchange quote
 * Cancel a single foreign exchange quote by its ID. If the quote has already been used by an outgoing transfer, it cannot be canceled. If the quote has already been canceled before, it will be returned.
 */
export const transferSwiftCancelFxQuote = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/international-wire/fx-rate/{fx_quote_id}/cancel',
        ...options,
    });
};
/**
 * List all realtime transfers
 * Retrieve all realtime transfers under your platform.
 */
export const transferRealtimeListTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime',
        ...options,
    });
};
/**
 * Create a realtime transfer
 * Create a realtime transfer between a Column account and a counterparty.
 */
export const transferRealtimeCreateTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a realtime transfer
 * Retrieve a single realtime transfer by its ID.
 */
export const transferRealtimeGetTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/{realtime_transfer_id}',
        ...options,
    });
};
/**
 * Return a realtime transfer
 * Return a realtime transfer by its ID.
 */
export const transferRealtimeReturnTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/{realtime_transfer_id}/return',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Create a realtime return request
 * Create a return request for a realtime transfer by its ID.
 */
export const transferRealtimeCreateReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/{realtime_transfer_id}/return-request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Review a Realtime transfer
 * Approve or reject a Realtime transfer that is pending review.
 */
export const transferRealtimeReviewTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/{realtime_transfer_id}/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all realtime RFPs
 * Retrieve all Realtime Requests for Payment (RFPs) under your platform.
 */
export const transferRealtimeListRfp = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/request-for-payment',
        ...options,
    });
};
/**
 * Create a realtime RFP
 * Create a Realtime Request For Payment (RFP) between a Column account and a counterparty.
 */
export const transferRealtimeCreateRfp = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/request-for-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a realtime RFP
 * Retrieve a single Realtime Request for Payment (RFP) by its ID.
 */
export const transferRealtimeGetRfp = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/request-for-payment/{realtime_rfp_id}',
        ...options,
    });
};
/**
 * Accept a realtime RFP
 * Accept an outstanding Realtime RFP by its ID. Only incoming Realtime RFPs with status presented or received can be accepted.
 */
export const transferRealtimeAcceptRfp = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/request-for-payment/{realtime_rfp_id}/accept',
        ...options,
    });
};
/**
 * Reject a realtime RFP
 * Reject an outstanding Realtime RFP by its ID. Only incoming Realtime RFPs in status presented or received can be rejected.
 */
export const transferRealtimeRejectRfp = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/request-for-payment/{realtime_rfp_id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all realtime return requests
 * Retrieve all Realtime returns under your developer account.
 */
export const transferRealtimeListReturnRequests = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/return-requests',
        ...options,
    });
};
/**
 * Get a realtime return request by ID
 * Retrieves a single Realtime return request by its ID.
 */
export const transferRealtimeGetReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/return-requests/{realtime_return_request_id}',
        ...options,
    });
};
/**
 * Accept a realtime return request
 * Accept an outstanding Realtime Return Request by its ID. Only incoming Realtime Return Requests with a pending status can be accepted.
 */
export const transferRealtimeAcceptReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/return-requests/{realtime_return_request_id}/accept',
        ...options,
    });
};
/**
 * Reject a realtime return request
 * Reject an outstanding Realtime Return Request by its ID. Only incoming Realtime Return Requests with a pending status can be rejected.
 */
export const transferRealtimeRejectReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/realtime/return-requests/{realtime_return_request_id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all wire transfers
 * Retrieve all wire transfers under your platform.
 */
export const transferWireListWireTransfers = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire',
        ...options,
    });
};
/**
 * Create a wire transfer
 * Create a wire transfer between a Column account and a counterparty.
 */
export const transferWireCreateWireTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get wire transfer
 * Retrieve a single wire transfer by its ID.
 */
export const transferWireGetWireTransfer = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/{wire_transfer_id}',
        ...options,
    });
};
/**
 * Create a wire return request
 * Sends an outgoing wire return request to request the return of funds of a previously sent outgoing wire transfer.
 */
export const transferWireCreateWireReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/{wire_transfer_id}/return-request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Reverse an incoming wire transfer
 * Reverse an incoming wire transfer received in error. You can read more about [Wire Reversals]({{wire.reversals}}).
 */
export const transferWireReverseWireTransfer = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/{wire_transfer_id}/reverse',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all wire drawdown requests
 * Retrieve all wire drawdowns under your developer account.
 */
export const transferWireListWireDrawdownRequests = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/drawdown',
        ...options,
    });
};
/**
 * Create a wire drawdown request
 * Sends an outgoing wire drawdown to request funds from an external account.
 */
export const transferWireCreateWireDrawdown = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/drawdown',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Get a wire drawdown request
 * Retrieves a single wire drawdown request by its ID.
 */
export const transferWireGetWireDrawdownRequest = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/drawdown/{wire_drawdown_request_id}',
        ...options,
    });
};
/**
 * Approve a wire drawdown request
 * Approves a single wire drawdown request by its ID. If approved, an outgoing wire is initiated using the information specified in the drawdown request.
 */
export const transferWireApproveWireDrawdownRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/drawdown/{wire_drawdown_request_id}/approve',
        ...options,
    });
};
/**
 * List all wire return requests
 * Retrieve all wire returns under your developer account.
 */
export const transferWireListWireReturnRequests = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/return-requests',
        ...options,
    });
};
/**
 * Get a wire return request
 * Retrieves a single wire return request by its ID.
 */
export const transferWireGetWireReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/return-requests/{wire_return_request_id}',
        ...options,
    });
};
/**
 * Approve a wire return request
 * Approves a single wire return request by its ID. If approved, an outgoing wire is initiated using the information specified in the return request.
 */
export const transferWireApproveWireReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/return-requests/{wire_return_request_id}/approve',
        ...options,
    });
};
/**
 * Reject a wire return request
 * Rejects a single wire return request by its ID. If rejected, a return response is sent to the requestor.
 */
export const transferWireRejectWireReturnRequest = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/transfers/wire/return-requests/{wire_return_request_id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List all webhook deliveries
 * List all the webhook delivery and retry attempts for this endpoint.
 */
export const webhookListEndpointWebhookDeliveries = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-deliveries/endpoint/{id}',
        ...options,
    });
};
/**
 * List webhook deliveries by event
 * List all the webhook delivery and retry attempts for this event.
 */
export const webhookListEventWebhookDeliveries = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-deliveries/event/{id}',
        ...options,
    });
};
/**
 * List all webhook endpoints
 * List all webhooks under your developer account.
 */
export const webhookListWebhookEndpoints = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-endpoints',
        ...options,
    });
};
/**
 * Create a webhook endpoint
 * Create a webhook URL and description. This can also be done on the [dashboard]({{dashboard}}).
 */
export const webhookCreateWebhookEndpoint = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-endpoints',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a webhook endpoint
 * Delete a webhook endpoint by its ID.
 */
export const webhookDeleteWebhookEndpoint = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-endpoints/{webhook_endpoint_id}',
        ...options,
    });
};
/**
 * Get a webhook endpoint
 * Retrieve a single webhook endpoint by its ID.
 */
export const webhookGetWebhookEndpoint = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-endpoints/{webhook_endpoint_id}',
        ...options,
    });
};
/**
 * Update a webhook endpoint
 * Update a webhook endpoint by its ID.
 */
export const webhookUpdateWebhookEndpoint = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-endpoints/{webhook_endpoint_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Verify a webhook endpoint
 * Send a test event to a webhook endpoint to verify it is configured correctly.
 */
export const webhookVerifyWebhookEndpoint = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook-endpoints/{webhook_endpoint_id}/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * List webhook deliveries by endpoint
 * @deprecated
 */
export const webhookListEndpointWebhookDeliveries2 = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_deliveries/endpoint/{id}',
        ...options,
    });
};
/**
 * List webhook deliveries by event
 * @deprecated
 */
export const webhookListEventWebhookDeliveries2 = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_deliveries/event/{id}',
        ...options,
    });
};
/**
 * List all webhook endpoints
 * @deprecated
 */
export const webhookListWebhookEndpoints2 = (options) => {
    return (options?.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_endpoints',
        ...options,
    });
};
/**
 * Create a webhook endpoint
 * @deprecated
 */
export const webhookCreateWebhookEndpoint2 = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_endpoints',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Delete a webhook endpoint
 * @deprecated
 */
export const webhookDeleteWebhookEndpoint2 = (options) => {
    return (options.client ?? _heyApiClient).delete({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_endpoints/{webhook_endpoint_id}',
        ...options,
    });
};
/**
 * Get a webhook endpoint
 * @deprecated
 */
export const webhookGetWebhookEndpoint2 = (options) => {
    return (options.client ?? _heyApiClient).get({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_endpoints/{webhook_endpoint_id}',
        ...options,
    });
};
/**
 * Update a webhook endpoint
 * @deprecated
 */
export const webhookUpdateWebhookEndpoint2 = (options) => {
    return (options.client ?? _heyApiClient).patch({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_endpoints/{webhook_endpoint_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
/**
 * Verify a webhook endpoint
 * @deprecated
 */
export const webhookVerifyWebhookEndpoint2 = (options) => {
    return (options.client ?? _heyApiClient).post({
        security: [
            {
                scheme: 'basic',
                type: 'http',
            },
        ],
        url: '/webhook_endpoints/{webhook_endpoint_id}/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};
//# sourceMappingURL=sdk.gen.js.map